export enum StatusSegmentedTitle {
  daily = '日次',
  monthly = '月次',
}
